<template>
  <div>
    <SettingsAutoupdate></SettingsAutoupdate>
    <SettingsMonitoring></SettingsMonitoring>
    <SettingsReport></SettingsReport>
  </div>
</template>

<script>

import SettingsAutoupdate from './SettingsAutoupdate'
import SettingsReport from './SettingsReport'
import SettingsMonitoring from './SettingsMonitoring'

export default {
  name: 'Settings',
  components: { SettingsAutoupdate, SettingsReport, SettingsMonitoring }
}
</script>
